import React from 'react';

type ViewType = 'key' | 'json';

interface ViewToggleProps {
  view: ViewType;
  setView: (view: ViewType) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ view, setView }) => {
  return (
    <div className="mb-6 flex bg-gray-200 p-1 rounded-md shadow-sm">
      <button
        onClick={() => setView('key')}
        className={`flex-1 px-4 py-2 text-sm font-medium rounded-md ${
          view === 'key'
            ? 'bg-white text-gray-800 shadow-sm'
            : 'text-gray-600 hover:text-gray-800'
        }`}
      >
        Key View
      </button>
      <button
        onClick={() => setView('json')}
        className={`flex-1 px-4 py-2 text-sm font-medium rounded-md ${
          view === 'json'
            ? 'bg-white text-gray-800 shadow-sm'
            : 'text-gray-600 hover:text-gray-800'
        }`}
      >
        JSON View
      </button>
    </div>
  );
};

export default ViewToggle;